<template>
  <section class="info-restaurante" v-if="restaurante.id" :style="estiloEvento">
    <share-button />
    <!-- 🖼 Imagen con degradado y overlay -->
    <div class="hero-image">
      <img :src="restaurante.logo" alt="logo restaurante" />
      <div class="hero-overlay">
        <div class="overlay-info">
          <div class="badges">
            <!-- ✅ Nombre del restaurante clickeable -->
            <span
              class="badge restaurante-verificado"
              @click="$router.push({ path: '/restaurante/' + restaurante.id })"
            >
              {{ restaurante.nombre }}
              <b-icon icon="check-circle" class="icono-verificado" />
            </span>

            <!-- 📱 Redes sociales -->
            <span
              class="badge icono"
              v-if="restaurante.instagram"
              @click="abrirInstagram"
            >
              <b-icon icon="instagram" />
            </span>
            <span
              class="badge icono"
              v-if="restaurante.facebook"
              @click="abrirFacebook"
            >
              <b-icon icon="facebook" />
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- ℹ️ Información -->
    <div class="p-4">
      <p class="mb-4" v-if="restaurante.descripcion">
        {{ restaurante.descripcion }}
      </p>

      <ul class="info mb-5">
        <li><b-icon icon="city" /> {{ restaurante.ciudad }}</li>

        <li class="direccion-mapa" @click="abrirEnMapa(restaurante.direccion)">
          <b-icon icon="map-marker" class="icono-mapa" />
          <span>{{ restaurante.direccion }}</span>
          <span class="mensaje-llegar">¡Ven a comer acá!</span>
        </li>

        <li class="whatsapp-link">
          <b-icon icon="whatsapp" class="icono-wapp" />
          <a
            :href="`https://wa.me/${restaurante.telefono}?text=Hola, quiero pedir por domicilio.`"
            target="_blank"
            class="texto-link"
          >
            {{ restaurante.telefono }}
            <span class="letrero-domicilio">¡Pide por WhatsApp!</span>
          </a>
        </li>
      </ul>

      <ul
        class="info mb-5"
        v-if="restaurante.direccion2 || restaurante.telefono2 || restaurante.ciudad2"
      >
        <li><b-icon icon="city" /> {{ restaurante.ciudad2 }}</li>

        <li class="direccion-mapa" @click="abrirEnMapa(restaurante.direccion2)">
          <b-icon icon="map-marker" class="icono-mapa" />
          <span>{{ restaurante.direccion2 }}</span>
          <span class="mensaje-llegar">¡Ven a comer acá!</span>
        </li>

        <li class="whatsapp-link">
          <b-icon icon="whatsapp" class="icono-wapp" />
          <a
            :href="`https://wa.me/${restaurante.telefono2}?text=Hola, quiero pedir por domicilio.`"
            target="_blank"
            class="texto-link"
          >
            {{ restaurante.telefono2 }}
            <span class="letrero-domicilio">¡Pide por WhatsApp!</span>
          </a>
        </li>
      </ul>

      <!-- 🍔 Productos -->
      <div class="opciones">
        <div class="opcion" @click="mostrarProductos = !mostrarProductos">
          <div class="opcion-titulo">
            <span>Productos</span>
            <b-icon :icon="mostrarProductos ? 'chevron-up' : 'chevron-down'" />
          </div>

          <transition name="fade">
            <div v-show="mostrarProductos" class="opcion-contenido">
              <ul class="lista-productos">
                <li
                  v-for="p in productos"
                  :key="p.id"
                  @click="irAProducto(p.id)"
                  class="badge badge-producto"
                >
                  <b-icon icon="food" class="mr-2" />
                  {{ p.nombre }}
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import HttpService from "../Servicios/HttpService";
import { ColorContrasteMixin } from "./mixins/ColorContrasteMixin";
import { ProductAccessMixin } from "./mixins/ProductAccessMixin";
import ShareButton from "./ShareButton.vue";

export default {
  name: "InfoRestaurante",
  components: { ShareButton },
  mixins: [ColorContrasteMixin, ProductAccessMixin],
  data() {
    return {
      restaurante: {},
      productos: [],
      mostrarProductos: false,
      cargando: false,
      eventoColor: "#fff",
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.obtenerDatos(id);
    this.obtenerColorEvento();
  },
  methods: {
    abrirInstagram() {
      window.open(this.restaurante.instagram, "_blank", "noopener");
    },
    abrirFacebook() {
      window.open(this.restaurante.facebook, "_blank", "noopener");
    },
    abrirEnMapa(dir) {
      const direccion = encodeURIComponent(dir);
      const url = `https://www.google.com/maps/search/?api=1&query=${direccion}`;
      window.open(url, "_blank");
    },
    async obtenerDatos(id) {
      this.cargando = true;
      const resRest = await HttpService.registrar("restaurantes.php", {
        accion: "obtener",
      });
      this.restaurante = (resRest || []).find((r) => r.id == id) || {};
      const resProd = await HttpService.registrar("productos.php", {
        accion: "obtener",
      });
      this.productos = (resProd || [])
        .filter((p) => p.restaurante_id == id)
        .sort(() => Math.random() - 0.5);
      this.cargando = false;
    },
    irAProducto(id) {
      if (!this.productsAreAvailable()) {
        this.showProductAlert();
        return;
      }
      this.$router.push({ name: "InfoProducto", params: { id } });
    },
    async obtenerColorEvento() {
      const res = await HttpService.registrar("eventos.php", {
        accion: "obtener",
      });

      if (Array.isArray(res) && res.length) {
        this.eventoColor = res[0].color_principal;
      }
    },
  },
  computed: {
    estiloEvento() {
      return {
        backgroundColor: this.eventoColor,
        color: this.colorContraste(this.eventoColor),
      };
    },
  },
};
</script>

<style scoped>
/* Contenedor general */
.info-restaurante {
  min-height: 100vh;
}

/* ===========================
   Hero Image + Overlay
   =========================== */
/* Hero + Overlay */
.hero-image {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
}
.hero-image img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end; /* pega al fondo */
  pointer-events: none;
}

/* Contenedor de badges */
.overlay-info {
  pointer-events: all;
  width: 100%;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  padding: 0.8rem 1rem;
  box-sizing: border-box;
}

/* Layout interno: nombre a la izquierda, RRSS a la derecha */
.overlay-info .badges {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
}

/* Badge de nombre: ocupa el espacio restante y trunca */
.badge.restaurante-verificado {
  flex: 1 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  padding: 0.4rem 0.8rem;
  border-radius: 12px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  transition: background 0.2s;
}
.badge.restaurante-verificado:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* Badges de iconos: tamaño fijo a la derecha */
.badge.icono {
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.15);
  padding: 0.4rem;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  transition: background 0.2s;
}
.badge.icono:hover {
  background: rgba(255, 255, 255, 0.25);
}
.badge.icono b-icon,
.badge.icono b-icon > svg {
  color: #fff !important;
  fill: #fff !important;
  stroke: #fff !important;
}

/* Icono de verificado en blanco */
.restaurante-verificado .icono-verificado {
  color: #fff !important;
  margin-left: 0.4rem;
}

/* ===========================
   Información secundaria
   =========================== */
.info li {
  margin-bottom: 0.5rem;
}

/* Dirección + animación “ven a comer” */
.direccion-mapa {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 0;
}

.icono-mapa {
  color: #ff5555;
}

.mensaje-llegar {
  background: #ff5555;
  color: #fff;
  font-size: 0.75rem;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: auto;
  animation: pulsar 2s infinite ease-in-out;
  white-space: nowrap;
}

/* WhatsApp link */
.whatsapp-link {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icono-wapp {
  color: #25d366;
  font-size: 1.2rem;
}

.letrero-domicilio {
  background: #25d366;
  color: #fff;
  font-weight: bold;
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 6px;
  margin-left: 8px;
  animation: salto 1.5s infinite ease-in-out;
  white-space: nowrap;
}

/* Animaciones */
@keyframes pulsar {
  0%, 100% { transform: scale(1); opacity: 1; }
  50%      { transform: scale(1.1); opacity: 0.85; }
}
@keyframes salto {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-6px); }
}

/* ===========================
   Sección Productos
   =========================== */
.opciones {
  border-top: 1px solid #eee;
}

.opcion {
  padding: 0.75rem 0;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}

.opcion-titulo {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lista-productos {
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 0.5rem;
}

.badge-producto {
  background: rgba(255, 255, 255, 0.1);
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 0.8rem;
  display: inline-flex;
  align-items: center;
  backdrop-filter: blur(6px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: background 0.2s ease;
}

.badge-producto:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ===========================
   Fade Transition
   =========================== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
